<template>
  <div>
    <div class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">

        <div class="flex justify-end ">
        <img class="cursor-pointer" width="20" src="../../../../../views/3pl/BillingandCollection/icons/icon-close.svg" alt="" @click="closeModal" />
        </div>

         <!-- <div class="flex justify-between "> -->
        <div class="flex items-center gap-4 ">
          <img width="35" src="../../../../../views/3pl/BillingandCollection/icons/star.svg" alt="star">
          <div>
            <h2 class="font-bold">{{ tierTitle }} Tier</h2>
            <p>Valid through {{validThrough}}</p>
          </div>
        </div>
        <!-- <img class="cursor-pointer" width="20" src="../../../../../views/3pl/BillingandCollection/icons/icon-close.svg" alt="" @click="closeModal" /> -->
        <!-- </div> -->

        <div class="w-full">
          <div class=" w-full mt-2  flex justify-between">
            <!-- <h3>{{ deliveriesToNextTier }} Deliveries</h3> -->
            <h3>{{ currentQuarterDeliveries }} Deliveries</h3>
            <p>{{ formattedPeriod() }}</p>
            <!-- <p>{{ formattedQualifyingPeriod }}</p> -->
          </div>
          <div class="delivery-progress-container">
            <div class="delivery-progress-bar" :style="{ width: deliveryProgress + '%' }"></div>
          </div>
        </div>

        <div id="scroller">

          <div class="px-2 py-2 mt-2">
            <p>You need to complete {{ deliveriesToNextTier }} additional deliveries
              to qualify for the Gold Tier, valid through {{validThrough}}.</p>
          </div>

          <div class="mt-2">
            <div class="flex justify-between">
              <p>Minimum Customer Rating:</p>
              <p>4.5</p>
            </div>
            <hr class="mt-2">
          </div>

          <div class="flex justify-between items-center mt-4 py-2 px-2">
            <div class="flex items-center gap-2">
              <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/star.svg" alt="star">
              <p>Unlocked Rewards (Silver)</p>
            </div>
            <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/unlock.svg" alt="padlock">
          </div>

          <div class=" mt-4 py-2 px-2">
            <div class="flex justify-between items-center ">
              <p>Commission on Deliveries</p>
              <p>15.0%</p>
            </div>
            <div v-for="(sr, index) in silverRewards" :key="index" class="flex justify-between items-center ">
              <p>{{ sr.name }}</p>
              
              <img width="20" :src="sr.content" alt="padlock">
            </div>
          </div>

          <div class="flex justify-between items-center mt-2 py-2 px-2">
            <div class="flex items-center gap-2">
              <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/people.svg" alt="star">
              <p>Additional Perks</p>
            </div>
            <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/unlock.svg" alt="padlock">
          </div>

          <div class=" mt-2 py-2 px-2">
              <p>Free monthly webinars on fleet & delivery business growth</p>
              <p>Dedicated partner support team to help you with billing, disputes, or scaling</p>
              <p>Invitations to annual meetups & appreciation events</p>
          </div>

          <hr class="mt-4">

          <div class=" mt-4 py-2 px-2">
          <div class="flex justify-between items-center  ">
            <div class="flex items-center gap-2">
              <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/gold.svg" alt="star">
              <p>Locked Rewards (Gold)</p>
            </div>
            <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/locked.svg" alt="padlock">
          </div>
          <p>Qualify for Gold Tier to unlock more rewards.</p>
          </div>

          <div class=" mt-4 py-2 px-2">
            <div class="flex justify-between items-center ">
              <p>Commission on Deliveries</p>
              <p>12.5%</p>
            </div>
            <div v-for="(gr, index) in goldRewards" :key="index" class="flex justify-between items-center ">
              <p>{{ gr.name }}</p>
              <img width="20" :src="gr.content" alt="padlock">
            </div>
          </div>

          <div class=" mt-4 py-2 px-2">
          <div class="flex justify-between items-center ">
            <div class="flex items-center gap-2">
              <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/diamond.svg" alt="star">
              <p>Locked Rewards (Diamond)</p>
            </div>
            <img width="25" src="../../../../../views/3pl/BillingandCollection/icons/locked.svg" alt="padlock">
          </div>
          <p>Qualify for Diamond Tier to unlock more rewards.</p>
          </div>

          <div class=" mt-4 py-2 px-2">
            <div class="flex justify-between items-center ">
              <p>Commission on Deliveries</p>
              <p>10%</p>
            </div>
            <div v-for="(dr, index) in diamondRewards" :key="index" class="flex justify-between items-center ">
              <p>{{ dr.name }}</p>
              <img width="20" :src="dr.content" alt="padlock">
            </div>
          </div>

          <div class="flex justify-end mt-2" @click="openWorkModal">
            <button class="py-2 px-4">
              How it works
            </button>
          </div>

        </div>

      </div>
    </div>

  </div>

</template>

<script>
import moment from "moment";
import checkMark from '../../../../../../public/icons/check-mark.svg';

export default {
  data() {
    return {
      silverRewards: [
        // { name: "Commission on Deliveries", perCent:  "15.0%"},
        { name: "Access to thousands of delivery orders in your area", content:  checkMark},
        { name: "Weekly performance insights (via dashboard & email)", content:  checkMark},
        { name: "Instant Cashout (get paid within 24 hours on completed deliveries)", content:  checkMark},
        { name: "Weekly payouts", content:  checkMark},
        { name: "Free “Verified Dispatcher” digital badge (to build trust on your social pages or website)", content:  checkMark},
        { name: "3rd Priority Access to batches", content:  checkMark},
        { name: "Weekly performance insights (via dashboard & email)", content:  checkMark},
        { name: "Real-time leaderboard with performance-based visibility", content:  checkMark},
        { name: "Access to general, support (chat, WhatsApp, virtual onboarding)", content:  checkMark},
      ],
        goldRewards: [
        // { name: "Commission on Deliveries", perCent:  "12.5%"},
        { name: "Instant Cashout (get paid within 24 hours on completed deliveries)", content:  checkMark},
        { name: "Weekly payouts", content:  checkMark},
        { name: "2nd level Priority matching to high-value or bulk delivery jobs", content:  checkMark},
        { name: "Access to cash on delivery jobs (up to 3 per cycle)", content:  checkMark},
        { name: "Route optimization feature (worth $30/month)", content:  checkMark},
        { name: "Free “Trusted Partner” digital badge (to build trust on your social pages or website)", content:  checkMark},
        { name: "Weekly performance reports + highlight mentions on leaderboard", content:  checkMark},
        { name: "Access to general, support (chat, WhatsApp, virtual onboarding)", content:  checkMark},
        { name: "Access to MuleEx community & support groups (best practices & platform updates)", content:  checkMark},
        { name: "Early access to beta features (optional opt-in)", content:  checkMark},
        { name: "Participation in logistics improvement surveys", content:  checkMark},
        
        ],
        diamondRewards: [
        // { name: "Commission on Deliveries", perCent:  "10%"},
        { name: "Instant Cashout (get paid within 24 hours on completed deliveries)", content:  checkMark},
        { name: "Weekly payouts", content:  checkMark},
        { name: "1st level priority matching to high-value or bulk delivery batches.", content:  checkMark},
        { name: "Access to unlimited cash on delivery jobs", content:  checkMark},
        { name: "Route optimization feature (worth $30/month)", content:  checkMark},
        { name: "Free “Top Partner” digital badge (to build trust on your social pages or website)", content:  checkMark},
        { name: "Weekly performance reports + highlight mentions on leaderboard", content:  checkMark},
        { name: "Access to priority support (chat, WhatsApp, virtual onboarding)", content:  checkMark},
        { name: "Access to MuleEx community & support groups (best practices & platform updates)", content:  checkMark},
        { name: "Early access to test new platform tools and features.", content:  checkMark},
        { name: "Eligible for end-of-year awards & top-performer recognition (certificate, blog feature, etc.)", content:  checkMark},
        { name: "Fully covered advanced logistics training & certifications (to grow your business)", content:  checkMark},
        { name: "Social media spotlight to help you grow your brand", content:  checkMark},
        { name: 'Eligible for "Courier of the Month" recognition (digital badge + app visibility)',  content: checkMark },
        { name: "Eligible for end-of-year awards & top-performer recognition (bonus, certificate, blog feature, etc.)", content:  checkMark},
        { name: "Free DPC health subscriptions*", content:  checkMark},
        ],
      currentTier: 'silver',
      validThrough: '',
      deliveriesToNextTier: '',
      qualifyingPeriod: null,
      currentTierProgress: '',
      currentQuarterDeliveries: '',
      maxDeliveries: '',
    };
  },

  methods: {
    formattedPeriod() {
      if (!this.qualifyingPeriod) return "";

      const start = moment(this.qualifyingPeriod.start).format("MMM D");
      const end = moment(this.qualifyingPeriod.end).format("MMM D");

      return `Qualifying Period: ${start} - ${end}`;
    },


    async getViewTierHistory() {
      let response = await this.$_getTeirCategory({ customerType: '3PL', fleetType: "Bike" })
      if (['silver', 'gold', 'platinum', 'diamond'].includes(response.data.currentTier?.toLowerCase())) {
        this.validThrough = response.data.validThrough;
        this.currentTier = response.data.currentTier;
        this.currentTierProgress = response.data.progressToNextTier;
        this.currentQuarterDeliveries = response.data.currentQuarterDeliveries;
        this.deliveriesToNextTier = response.data.deliveriesToNextTier;
        this.qualifyingPeriod = response.data.qualifyingPeriod;
        this.maxDeliveries = response.data.nextTierRange.maxDeliveries
      } else {
        this.currentTier = response.data.currentTier;
      }
    },

    closeModal() {
      this.$emit("close-modal", close)
    },
    openWorkModal() {
      this.$emit("open-work-modal", open)
    }

  },
  computed: {
    //   deliveryProgress() {
    //   const delivered = this.deliveriesToNextTier;
    //   const max = this.maxDeliveries;

    //   if (!delivered || !max) return 0;
    //   return (delivered / max) * 100; // result in %
    // },
    deliveryProgress() {
      const p = this.currentTierProgress; // string: "24.49%"
      return Number(p.replace('%', ''));  // convert to number: 24.49
    },

    formattedQualifyingPeriod() {
      const qp = this.qualifyingPeriod;
      if (!qp || !qp.start || !qp.end) return '';

      // parse the backend strings explicitly
      const start = moment(qp.start, 'YYYY-MM-DD');
      const end = moment(qp.end, 'YYYY-MM-DD');

      // if same month & year you could display "Oct 1 - 31", but you asked for "MMM D - MMM D"
      const startStr = start.format('MMM D');   // "Oct 1"
      const endStr = end.format('MMM D');     // "Dec 31"

      return `Qualifying Period: ${startStr} - ${endStr}`;
    },
    tierTitle() {
      switch (this.currentTier) {
        case 'Silver':
          return 'Silver';
        case 'No Tier':
          return 'No Tier';
        case 'Gold':
          return 'Gold';
        case 'Platinum':
          return 'Platinum';
        case 'Diamond':
          return 'Diamond';
        default:
          return 'No Tier';
      }
    },
    tierPercentage() {
      switch (this.currentTier) {
        case 'Silver':
          return '15%';
        case 'gold':
          return '25%';
        case 'platinum':
          return '35%';
        case 'diamond':
          return '45%';
        case 'No Tier':
          return '';
        default:
          return '';
      }
    },
  },
  mounted() {
    this.getViewTierHistory()
  },

}
</script>

<style scoped>
.delivery-progress-container {
  width: 100%;
  height: 6px;
  background: #DAE8F6;
  /* light blue/grey like your screenshot */
  border-radius: 4px;
  overflow: hidden;
}

.delivery-progress-bar {
  height: 100%;
  background: #09B78A;
  /* the green from your UI */
  transition: width 0.6s ease;
  /* smooth animation */
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  /* align-items: center; */
  z-index: 9999;
}

.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
}

#scroller {
  max-height: 500px;
  overflow-y: auto;
}
.modal-content>:nth-child(1) {
  /* border: 1px solid blue; */
}

.modal-content>:nth-child(4)>:nth-child(1) {
  background-color: #F2F7FC;
  border-radius: 8px;
}

.modal-content>:nth-child(4)>:nth-child(1) p {
  color: #383F51;
  font-size: 14px;
  font-weight: 400;
}

.modal-content>:nth-child(4)>:nth-child(2)>div p {
  color: #7A90A7;
  font-size: 14px;
  font-weight: 400;
}

.modal-content>:nth-child(4)>:nth-child(2) hr {
  border: 0.5px solid #7A90A7;
}

.modal-content>:nth-child(4)>:nth-child(3),
.modal-content>:nth-child(4)>:nth-child(4) {
  border: 1px solid #09B78A;
  background-color: #F2F7FC;
  border-radius: 8px;
}

.modal-content>:nth-child(4)>:nth-child(3)>div p {
  color: #383F51;
  font-size: 12px;
  font-weight: 600;
}

.modal-content>:nth-child(4)>:nth-child(5) {
  border: 1px solid #F7B538;
  background-color: #F7B5380D;
  border-radius: 8px;
}

.modal-content>:nth-child(4)>:nth-child(5)>div p {
  color: #14171F;
  font-weight: 600;
  font-size: 12px;
}

.modal-content>:nth-child(4)>:nth-child(6) {
  border: 1px solid #F7B538;
  background-color: #F7B5380D;
  border-radius: 8px;
}

.modal-content>:nth-child(4)>:nth-child(6)>div p {
  color: #14171F;
  font-weight: 400;
  font-size: 12px;
}
.modal-content>:nth-child(4)>:nth-child(7)  {
  border: 0.5px solid #7A90A7;
}

.modal-content>:nth-child(4)>:nth-child(8),
.modal-content>:nth-child(4)>:nth-child(9) {
  border: 1px solid #10233E;
  background-color: #F2F7FC;
  border-radius: 8px;
}

.modal-content>:nth-child(4)>:nth-child(8)>div p {
  color: #383F51;
  font-size: 12px;
  font-weight: 600;
}

.modal-content>:nth-child(4)>:nth-child(10),
.modal-content>:nth-child(4)>:nth-child(11) {
  border: 1px solid #10233E;
  background-color: #F2F7FC;
  border-radius: 8px;
}

.modal-content>:nth-child(4)>:nth-child(10)>div p {
  color: #383F51;
  font-size: 12px;
  font-weight: 600;
}

.modal-content>:nth-child(4)>:nth-child(12) button {
  border: none;
  background-color: #10233E;
  color: #EBF2FA;
  border-radius: 8px;
  font-size: 16px;
}

h2 {
  font-size: 16px;
  color: #383F51;
}



p {
  font-weight: 400;
  font-size: 12px;
  color: #7A90A7;
}

h3 {
  font-weight: 600;
  font-size: 14px;
  color: #09B78A;
}
</style>